import { render, staticRenderFns } from "./PeriodicalBox.vue?vue&type=template&id=706f5164&scoped=true"
import script from "./PeriodicalBox.vue?vue&type=script&lang=js"
export * from "./PeriodicalBox.vue?vue&type=script&lang=js"
import style0 from "./PeriodicalBox.vue?vue&type=style&index=0&id=706f5164&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706f5164",
  null
  
)

export default component.exports